/**
 * List of events used by reviews teaser widget
 *
 */
export const reviewsTeaser = {
  REVIEWS_TEASER_LOADED: 'loaded',
  REVIEWS_TEASER_MODAL_OPENED: 'reviewsModalOpened'
}
